import * as React from 'react'
import I18n from '../../../../core/i18n'
import { adminService } from '../../../../core/services'
import { InputText, Select, SelectWithSearch, Spacer } from '../../../atoms'
import AdminLayoutNew from '../_layouts/new'

interface IProps {
  banks: any
}

const FIELDS = {
  post_id: 'post_id',
  bank_id: 'bank_id',
  account_type: 'account_type',
  number: 'number',
  name: 'name',
  branch_code: 'branch_code',
}

const title = I18n.t('admin.create_new', {
  model: I18n.t('bank_account', { scope: 'activerecord.models' }),
})

const accountTypeOptions = [
  { value: 'saving', label: '普通' },
  { value: 'checking', label: '当座' },
]

const AdminBankAccountNew: React.FC<IProps> = props => {
  const [posts, setPosts] = React.useState([])

  const formatSelectOptions = options => {
    return options.map((option: { id: number; name: string }) => ({
      value: option.id,
      label: option.name,
    }))
  }

  const formatBankOptions = options => {
    return options.map((option: { id: number; name: string; code: string }) => ({
      value: option.id,
      label: `${option.name}/${option.code}`,
    }))
  }

  const getPosts = async () => {
    const { postList } = await adminService.getPosts()
    setPosts([{ value: '', label: '-' }, ...formatSelectOptions(postList)])
  }
  React.useEffect(() => {
    getPosts()
  }, [])

  const bankList = formatBankOptions(props.banks)
  const [banks, setBanks] = React.useState(bankList)

  const handleSubmit = React.useCallback(async (initialValues, values) => {
    const { createdBankAccount, flush } = await adminService.createBankAccount(values)
    // TODO 遷移先でのFlush
    location.href = '/admin/bank_accounts'
  }, [])

  return (
    <AdminLayoutNew
      model="bank_account"
      title={title}
      fields={FIELDS}
      indexLink="/admin/bank_accounts"
      formItems={
        <>
          <SelectWithSearch options={posts} label="店舗" name="post_id" required={true} />
          <Spacer />
          <SelectWithSearch options={banks} label="銀行コード" name="bank_id" required={true} />
          <Spacer />
          <InputText required={true} name="branch_code" defaultValue="" label="支店コード" />
          <Spacer />
          <Select
            required={true}
            name="account_type"
            label="口座種別"
            options={accountTypeOptions}
            defaultValue={''}
          />
          <Spacer />
          <InputText required={true} name="number" defaultValue="" label="口座番号" />
          <Spacer />
          <InputText required={true} name="name" defaultValue="" label="口座名義" />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AdminBankAccountNew
